import React from 'react';

export const Title_Modal_Consult = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>CONSULTA</span>,
  },
];

export const Title_Modal = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>CREA CON NOSOTROS</span>,
  },
];

export const TitleJoin_Modal = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>ÚNETE AL EQUIPO</span>,
  },
];

export const TitlePrac_Modal = [
  {
    textSize: '3rem',
    marginBottom: '3.75rem;',
    textType: 'h2',
    renderContent: () => <span>PRÁCTICAS / SERVICIO SOCIAL</span>,
  },
];
